export const BUCHAREST_COORDINATES = {
  lat: 44.42801,
  lng: 26.102619,
};
